import styled from "@emotion/styled"
import { PAccordion, PHeading, PTag } from "@porsche-design-system/components-react"
import type { AccordionUpdateEventDetail } from "@porsche-design-system/components-react"
import { colorContrastLower, spacingStaticMd, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { useCallback, useState } from "react"
import type { PropsWithChildren } from "react"
import { NewBadge } from "../badge/NewBadge"

interface VehicleListFilterProps extends PropsWithChildren {
	activeFilterCount: number | undefined
	initiallyOpen?: boolean
	isNew?: boolean
	title: string
}
export const VehicleListFilter = ({
	activeFilterCount,
	children,
	initiallyOpen,
	isNew,
	title,
	...rest
}: VehicleListFilterProps) => {
	const [isOpen, setIsOpen] = useState(initiallyOpen ?? !!activeFilterCount)

	const handleFilterToggle = useCallback(
		(event: CustomEvent<AccordionUpdateEventDetail>) => setIsOpen(event.detail.open),
		[],
	)

	return (
		<StyledAccordion open={isOpen} onUpdate={handleFilterToggle} {...rest}>
			<PHeading size="sm" slot="summary">
				{title}
				{isNew && <StyledNewBadge compact />}
			</PHeading>
			{!!activeFilterCount && (
				<PTag slot="summary-after" compact>
					{activeFilterCount}
				</PTag>
			)}
			{children}
		</StyledAccordion>
	)
}

const StyledNewBadge = styled(NewBadge)`
	margin-inline-start: ${spacingStaticSm};
`

const StyledAccordion = styled(PAccordion)`
	&:not(:first-child) {
		padding-top: ${spacingStaticMd};
		border-top: 1px solid ${colorContrastLower};
	}
	
	&:not(:last-child) {
		padding-bottom: ${spacingStaticMd};
	}
`
